<h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>{{ data.content }}</mat-dialog-content>
    <mat-dialog-actions align="end">
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Nein</button>
  <button mat-raised-button color="warn" (click)="onYesClick()">Ja</button>
</mat-dialog-actions>